import projectDetailFragment from './Fragments/projectDetailFragment'

const updateCustomerProjectQuery = /* GraphQL */ `
  mutation UpdateCustomerProject($projectRequest: ProjectRequestInput = null) {
    updateCustomerProject(projectRequest: $projectRequest) {
      success
      updatedEngineIds
      projects {
        ...ProjectDetailFragment
      }
      webUser {
        userGuid
      }
      message
      updatedCustomerProjectId
    }
  }
  ${projectDetailFragment}
`

export default updateCustomerProjectQuery
